module.exports = __webpack_public_path__ + "media/src/images/icon/fa-ig-39cd1c9d737551a3131c7caa150c9eb3.png";